import { render, staticRenderFns } from "./SettingsJobLevels.vue?vue&type=template&id=067616e0"
import script from "./SettingsJobLevels.vue?vue&type=script&lang=js"
export * from "./SettingsJobLevels.vue?vue&type=script&lang=js"
import style0 from "./SettingsJobLevels.vue?vue&type=style&index=0&id=067616e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports